module.exports = __webpack_public_path__ + "img/icon_re_bg.ade8e6a3.png";